import { QueryClientProvider } from '@tanstack/react-query';
import React from 'react';

import { AuthUnavailable } from '@/components/auth-unavailable';
import { useAuthRecovery } from '@/hooks';
import { getQueryClient } from '@/lib/query-client';
import { TRPCProvider } from '@/lib/trpc';

interface ApiProviderProps {
  children: React.ReactNode;
}

const ApiProvider = ({ children }: ApiProviderProps): React.JSX.Element => {
  const queryClient = getQueryClient();
  const { authUnavailable, trpcClient } = useAuthRecovery();

  if (authUnavailable) {
    return <AuthUnavailable onRetry={() => window.location.reload()} />;
  }

  return (
    <QueryClientProvider client={queryClient}>
      <TRPCProvider trpcClient={trpcClient} queryClient={queryClient}>
        {children}
      </TRPCProvider>
    </QueryClientProvider>
  );
};

export default ApiProvider;
